var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:[_vm.classes, {'invert' : _vm.theme != _vm.themeProp}],attrs:{"width":_vm.width,"alt":"icona","src":_vm.src + _vm.theme + '.svg'}})
}
var staticRenderFns = []

export { render, staticRenderFns }